(function () {
  if (window.__impactLongPressInitV2) return;
  window.__impactLongPressInitV2 = true;

  var LONG_PRESS_MS = 100;

  function setup(cardEl) {
    if (!cardEl || cardEl.dataset.lpReady === '1') return;

    var wrapper = cardEl.querySelector('.product-card');
    if (!wrapper) return;

    var link = cardEl.querySelector('.product-card__figure > a') || wrapper.querySelector('a');
    if (!link) return;

    cardEl.dataset.lpReady = '1';

    var timer = null;
    var longPressed = false;

    function clearTimer() {
      if (timer) { clearTimeout(timer); timer = null; }
    }

    function startPress(e) {
      if (e.pointerType && e.pointerType !== 'touch') return;
      clearTimer();
      longPressed = false;
      timer = setTimeout(function () {
        longPressed = true;
        wrapper.classList.add('is-touch-hover');
      }, LONG_PRESS_MS);
    }

    function endPress(e) {
      clearTimer();
      if (longPressed && e) {
        try { e.preventDefault(); e.stopPropagation(); } catch (_) {}
      }
      setTimeout(function () {
        wrapper.classList.remove('is-touch-hover');
        longPressed = false;
      }, 120);
    }

    link.addEventListener('pointerdown', startPress, { passive: true });
    link.addEventListener('pointerup', endPress, { passive: false });
    link.addEventListener('pointercancel', endPress, { passive: true });
    link.addEventListener('pointerleave', endPress, { passive: true });

    link.addEventListener('touchmove', clearTimer, { passive: true });

    link.addEventListener('click', function (e) {
      if (longPressed) {
        try { e.preventDefault(); e.stopPropagation(); } catch (_) {}
        longPressed = false;
        wrapper.classList.remove('is-touch-hover');
      }
    }, true);
  }

  function initAll() {
    document.querySelectorAll('product-card').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var mo = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var node = m.addedNodes[j];
        if (!(node instanceof Element)) continue;
        if (node.tagName && node.tagName.toLowerCase() === 'product-card') setup(node);
        node.querySelectorAll && node.querySelectorAll('product-card').forEach(setup);
      }
    }
  });

  var productContainer = document.querySelector('.collection, .search-results, [data-product-list]');
  if (productContainer) {
    mo.observe(productContainer, { childList: true, subtree: true });
  } else {
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('pagehide', function () { mo.disconnect(); });
})();
